import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: 'Outstanding Invoices',
	url: '/collections/outstanding_invoices',
	icon: 'dashboard'
}];

export default class OutstandingInvoices extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	triggerReload = () => {
		this.setState({refresh: !this.state.refresh})
	}

	render() {
		let {history} = this.props;
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}>
					<Button data-cy="add-customer" onClick={this.toggle('modalInvoiceAdd')} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Invoice
					</Button>
				</Framework.Components.PageBar>

				<Collections.Outstanding_Invoices history={history} reloadSelf={this.state.refresh}
				                                  triggerReload={this.triggerReload}/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Invoice"}
					object={Objects.OutstandingInvoice}
					toggle={this.state.modalInvoiceAdd}
					reportClose={this.reportClose('modalInvoiceAdd')}
					afterSave={this.triggerReload}
					hideGoTo={true}
				/>

			</div>
		)
	}
}